import { isIE11 } from '@opengov/app-core/utils/browserUtils';
import { enableES5 } from 'immer';

if (isIE11()) {
  enableES5();
}

import { effects } from './module/effects';
import { middleware } from './module/middleware';
import { exportModule } from './module/module';
import { reportConfigurationStateBranchKey, state } from './module/state';

interface IReportModuleParams {
  shouldPersistReportConfigurations?: boolean;
}

export const BaseReportModule = exportModule<any, any, any>({
  effects,
  middleware,
  state
});

export const ReportModule = (params?: IReportModuleParams) => {
  if (params) {
    const reportConfigStateIndex = state.findIndex((s) => s.branchKey === reportConfigurationStateBranchKey);
    return exportModule({
      effects,
      middleware,
      state: state.setIn(
        [reportConfigStateIndex, 'initialState', 'shouldPersistReportConfigurations'],
        params.shouldPersistReportConfigurations
      ) as any
    });
  }
  return exportModule<any, any, any>({
    effects,
    middleware,
    state
  });
};
